import * as React from 'react';

const DiscordIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20.162}
    height={14.5}
    {...props}
  >
    <path
      data-name="Path 69"
      d="M17.675 1.812A8.532 8.532 0 0 0 12.825 0l-.242.276a11.484 11.484 0 0 1 4.3 2.192 14.066 14.066 0 0 0-5.2-1.658 14.608 14.608 0 0 0-3.487.035 1.636 1.636 0 0 0-.293.034 12.956 12.956 0 0 0-3.919 1.088c-.638.293-1.018.5-1.018.5A11.643 11.643 0 0 1 7.505.205l-.172-.207A8.537 8.537 0 0 0 2.482 1.81 23.12 23.12 0 0 0-.003 11.873a6.254 6.254 0 0 0 5.264 2.624s.64-.776 1.158-1.433a5.369 5.369 0 0 1-3.021-2.037s.172.12.483.293a.218.218 0 0 0 .07.052c.052.034.1.052.155.086a10.211 10.211 0 0 0 1.26.588 14.516 14.516 0 0 0 2.538.742 12.091 12.091 0 0 0 4.47.017 11.381 11.381 0 0 0 2.5-.742 9.87 9.87 0 0 0 1.985-1.018 5.448 5.448 0 0 1-3.125 2.054c.518.656 1.14 1.4 1.14 1.4a6.31 6.31 0 0 0 5.282-2.624 23.111 23.111 0 0 0-2.481-10.063ZM6.85 10.271a1.851 1.851 0 0 1-1.761-1.916A1.839 1.839 0 0 1 6.85 6.44a1.828 1.828 0 0 1 1.761 1.916 1.839 1.839 0 0 1-1.761 1.915Zm6.3 0a1.85 1.85 0 0 1-1.761-1.916A1.839 1.839 0 0 1 13.15 6.44a1.84 1.84 0 0 1 1.761 1.916 1.84 1.84 0 0 1-1.761 1.915Z"
      fill={props.color}
    />
  </svg>
);

export default DiscordIcon;
